import React, { useEffect, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { MODES_OPTIONS } from "@app/types/generics.types";
import { MAutocomplete, ResponsiveFormContainer } from "@app/components";
import { PROCESS_OPTIONS, setsBackgroundForm } from "../utils/constans";
import CommonForm from "./subforms/commonForm";

interface BackgoundFormProps {
  mode: MODES_OPTIONS;
}

const BackgroundForm = ({ mode }: BackgoundFormProps) => {
  const form = useFormContext();

  const isView = mode === MODES_OPTIONS.VIEW;
  const isEdit = mode === MODES_OPTIONS.EDIT;

  const selectedFondotype = form.watch("type");
  const watchCountingTime = form.watch("counting_time");

  useEffect(() => {
    if (selectedFondotype) {
      const entry = setsBackgroundForm.find(
        (item) => item.type === selectedFondotype.value
      );
      if (!watchCountingTime) {
        form.setValue("counting_time", entry?.counting_time);
      }
    }
  }, [selectedFondotype, watchCountingTime, form]);

  const CurrentComponent = useMemo(() => {
    if (selectedFondotype) {
      const entry = setsBackgroundForm.find(
        (item) => item.type === selectedFondotype.value
      );
      return entry ? entry.component : null;
    }
    return null;
  }, [selectedFondotype]);

  return (
    <>
      <Box mt={2}>
        <ResponsiveFormContainer columns={5}>
          <MAutocomplete
            key={JSON.stringify(form.getValues("type"))}
            name="type"
            options={PROCESS_OPTIONS}
            label="Selecciona un tipo de fondo"
            getOptionLabel={(option) => option.label}
            disabled={isView || isEdit}
          />
        </ResponsiveFormContainer>
      </Box>

      <Box mt={2}>
        {CurrentComponent ? (
          <>
            <CommonForm disable={isView} />
            <CurrentComponent disable={isView} />
          </>
        ) : (
          <Typography variant="body1">
            Selecciona un tipo de fondo para continuar.
          </Typography>
        )}
      </Box>
    </>
  );
};

export default BackgroundForm;
